module.exports = __webpack_public_path__ + "img/danskebank.4823e410.jpg";